import { render, staticRenderFns } from "./EmptyStateNoData.vue?vue&type=template&id=1bfb4b5c"
import script from "./EmptyStateNoData.vue?vue&type=script&lang=js"
export * from "./EmptyStateNoData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports